/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { PostApiBarberAppointmentsIdComplete200, PostApiBarberAppointmentsIdComplete400, PostApiBarberAppointmentsIdComplete401, PostApiBarberAppointmentsIdComplete403, PostApiBarberAppointmentsIdComplete404, PostApiBarberAppointmentsIdComplete500, PostApiBarberAppointmentsIdCompleteMutationResponse, PostApiBarberAppointmentsIdCompletePathParams } from "../entities/PostApiBarberAppointmentsIdComplete";
import { modelsErrorResponseSchema } from "./models/errorResponseSchema";
import { modelsMessageResponseSchema } from "./models/messageResponseSchema";
import { z } from "zod/v4";

export const postApiBarberAppointmentsIdCompletePathParamsSchema = z.object({
    "id": z.coerce.number().int().describe("ID записи")
    }) as unknown as z.ZodType<PostApiBarberAppointmentsIdCompletePathParams>

/**
 * @description OK
 */
export const postApiBarberAppointmentsIdComplete200Schema = z.lazy(() => modelsMessageResponseSchema) as unknown as z.ZodType<PostApiBarberAppointmentsIdComplete200>

/**
 * @description Bad Request
 */
export const postApiBarberAppointmentsIdComplete400Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberAppointmentsIdComplete400>

/**
 * @description Unauthorized
 */
export const postApiBarberAppointmentsIdComplete401Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberAppointmentsIdComplete401>

/**
 * @description Forbidden
 */
export const postApiBarberAppointmentsIdComplete403Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberAppointmentsIdComplete403>

/**
 * @description Not Found
 */
export const postApiBarberAppointmentsIdComplete404Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberAppointmentsIdComplete404>

/**
 * @description Internal Server Error
 */
export const postApiBarberAppointmentsIdComplete500Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberAppointmentsIdComplete500>

export const postApiBarberAppointmentsIdCompleteMutationResponseSchema = z.lazy(() => postApiBarberAppointmentsIdComplete200Schema) as unknown as z.ZodType<PostApiBarberAppointmentsIdCompleteMutationResponse>